import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum";
import { projectCreatePath } from "@/ts/apiRoutes";

export const useProjectCreateStore = defineStore('project-create',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function create(data: object) {
        const response = await request(`${projectCreatePath}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
        }

        return response
    }

    return { status, create }
})